<template>
  <header class="header">
    <nav class="nav">
      <div class="logo">
        <router-link to="/" exact>
          <img
            :src="require('@/assets/images/logo.png')"
            alt="KisiAI"
            width="64"
            height="64"
          />
        </router-link>
      </div>
      <div class="navLinks">
        <router-link to="/" exact>首页</router-link>
        <router-link to="/video-translation">视频翻译</router-link>
        <router-link to="/video-swapping">视频换脸</router-link>
        <router-link to="/sound-cloning">声音克隆</router-link>
        <router-link to="/pricing">定价</router-link>
      </div>
      <div class="navActions">
        <router-link to="/contact" class="navLink">联系我们</router-link>
        <button 
          class="button buttonPrimary"
          @click="handleStart"
        >
          开始使用
        </button>
      </div>
    </nav>
  </header>
</template>

<script>
import { handleStart } from '@/utils/navigation'

export default {
  name: 'Header',
  
  computed: {
    isAuthenticated() {
      return this.$store && this.$store.state.auth && this.$store.state.auth.token != null
    }
  },

  methods: {
    handleStart() {
      handleStart(this.$router, this.$store)
    }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(8px);
  z-index: 50;
  border-bottom: 1px solid rgba(229, 231, 235, 0.5);
}

.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.logo {
  display: flex;
  align-items: center;
}

.logo img {
  height: 64px;
  width: auto;
}

.logo a {
  display: flex;
  align-items: center;
  gap: 2px;
  text-decoration: none;
}

.betaTag {
  font-size: 0.75rem;
  padding: 0.125rem 0.375rem;
  background-color: #6366F1;
  color: white;
  border-radius: 0.25rem;
  margin-left: 0.5rem;
  font-weight: 600;
}

.navLinks {
  display: flex;
  gap: 2.5rem;
  align-items: center;
}

.navLinks a {
  color: #4B5563;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.01em;
  padding: 8px 0;
  position: relative;
  transition: all 0.2s ease;
}

.navLinks a:hover {
  color: #6366F1;
}

.navLinks a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: #6366F1;
  transition: width 0.2s ease;
}

.navLinks a:hover::after {
  width: 100%;
}

.navLinks a.router-link-active {
  color: #6366F1;
  font-weight: 600;
}

.navLinks a.router-link-active::after {
  width: 100%;
}

.navActions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.button {
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.2s;
}

.buttonPrimary {
  background-color: #6366F1;
  color: white;
  border: none;
  box-shadow: 0 2px 4px rgba(99, 102, 241, 0.2);
}

.buttonPrimary:hover {
  background-color: #4F46E5;
  transform: translateY(-1px);
}

@media (max-width: 768px) {
  .navLinks {
    display: none;
  }
  
  .navActions {
    gap: 0.5rem;
  }
  
  .button {
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 600;
  }
}
</style> 